import { Pipe, PipeTransform } from '@angular/core';
import { format, differenceInCalendarDays } from 'date-fns';

@Pipe({
  standalone: false,
  name: 'propertyCalEventWidth',
})
export class PropertyCalEventWidthPipe implements PipeTransform {
  transform(start: any, reservation: any, isMobile: boolean): any {
    const dayDiff = differenceInCalendarDays(reservation.display_end, start);

    const dayWidth = isMobile ? 53 : 91;

    const notTrueStartWidth = reservation.display_start !== format(reservation.checkin, 'YYYY-MM-DD') ? 26 : 0;

    const notTrueEndWidth = reservation.display_end !== format(reservation.checkout, 'YYYY-MM-DD') ? dayWidth : 0;

    return dayDiff * dayWidth + notTrueStartWidth + notTrueEndWidth;
  }
}
